module.exports = __webpack_public_path__ + "img/ASQ_logo_draft_highres.d45c930c.png";